﻿import {EuronicsResponse} from "@/interfaces";

/*
Callback for EuronicsResponse handling
- if htmlTarget is provided, then htmlTarget innerHTML is replaced with EuronicsResponse.Html 
- if jsonCallback is provided, then EuronicsResponse.Data is passed to jsonCallback function for handling
- if EuronicsResponse.Redirect is present, then a redirect is made to that URL 
*/
export function EuronicsResponseHandler(resp: EuronicsResponse, jsonCallback?: Function, htmlTarget?: HTMLElement) {
    if (!!htmlTarget) {
        htmlTarget.innerHTML = resp.html;
    }

    if (!!jsonCallback) {
        jsonCallback(resp.data)
    }

    if (!!resp.redirect) {
        window.location.href = resp.redirect;
    }
}

/*
Same as EuronicsResponseHandler, but used in fetch requests when Response is not resolved to JSON before passing to callback
e.g. processFetchResponse
*/
export function EuronicsResponsePromiseHandler(resp: Response, jsonCallback?: Function, htmlTarget?: HTMLElement) {
    resp.json().then((r: EuronicsResponse) => EuronicsResponseHandler(r, jsonCallback, htmlTarget))
}